import { useEffect, useState, useCallback } from "react";
import { Factory } from "lucide-react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import ListToolbar from "@/components/ListToolbar";

export default function ManufacturerStock() {
  const [items, setItems] = useState([]);
  const [cities, setCities] = useState([]);
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({ size: "", surface: "", city: "" });
  const [sort, setSort] = useState("newest");
  const [options, setOptions] = useState({ sizes: [], surfaces: [] });

  useEffect(() => {
    api.get("/cities?active=true").then(({ data }) => setCities(data));
    api.get("/product-options").then(({ data }) => setOptions(data));
  }, []);

  const load = useCallback(async () => {
    const p = new URLSearchParams();
    if (search) p.set("q", search);
    if (filters.size) p.set("size", filters.size);
    if (filters.surface) p.set("surface", filters.surface);
    if (filters.city) p.set("city", filters.city);
    p.set("sort", sort);
    const { data } = await api.get(`/manufacturer-stock?${p.toString()}`);
    setItems(data);
  }, [search, filters, sort]);

  useEffect(() => { const t = setTimeout(load, 200); return () => clearTimeout(t); }, [load]);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-heading text-2xl font-extrabold flex items-center gap-2"><Factory className="h-6 w-6 text-primary" /> Manufacturer Stock (B2B)</h1>
        <p className="text-muted-foreground text-sm font-medium">Authorized manufacturer clearance stock, visible only to you.</p>
      </div>

      <ListToolbar
        placeholder="Search manufacturer stock…"
        search={search} setSearch={setSearch}
        filters={[
          { key: "size", label: "Size", value: filters.size, options: options.sizes.map((s) => ({ value: s, label: s })) },
          { key: "surface", label: "Surface", value: filters.surface, options: options.surfaces.map((s) => ({ value: s, label: s })) },
          { key: "city", label: "City", value: filters.city, options: cities.map((c) => ({ value: c.name, label: c.name })) },
        ]}
        onFilter={(k, v) => setFilters((f) => ({ ...f, [k]: v }))}
        sort={sort} setSort={setSort}
        sorts={[{ value: "newest", label: "Newest" }, { value: "price_low", label: "Price ↑" }, { value: "price_high", label: "Price ↓" }]}
        onReset={() => { setSearch(""); setFilters({ size: "", surface: "", city: "" }); setSort("newest"); }}
      />

      {items.length === 0 ? (
        <div className="text-center py-16 text-muted-foreground font-semibold">No manufacturer stock available.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {items.map((p, i) => <ProductCard key={p.id} p={p} index={i} b2b />)}
        </div>
      )}
    </div>
  );
}
